import { createAction } from '@reduxjs/toolkit'

import { IRealEstate } from 'types/GlobalRealEstate'

// tryGetAllRealEstates
export const getAll = createAction('get_all_real_estates')
export const getAllSuccess = createAction<{ data: IRealEstate[] }>(
  'get_all_real_estates_success'
)
export const getAllFailed = createAction('get_all_real_estates_failed')
